// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__FLcrE","legacyBtn":"MutateMid_legacyBtn__k6BiL"};